<template>
	<div class="h-[1.25rem] w-full rounded-sm">
		<TimelineEvent
			:event="event"
			:class="[
				`specialDiscountEvent`,
				{ 'cursor-pointer': isClickable && !readonly, 'cursor-default': !isClickable || readonly, 'is-selected': isSelected }
			]"
			:style="portalColorVar"
			:tooltip-max-width="650"
			:with-dimmer-inset="false"
		>
			<template #body>
				<span class="font-caption overflow-hidden text-ellipsis whitespace-nowrap"> {{ event.name }} </span>
			</template>

			<template #tooltipTitleContent>
				<span>{{ title }}</span>
			</template>

			<template #tooltipBody>
				<span>{{ dateTimeFormattedShort(event.start_date) }} - {{ dateTimeFormattedShort(event.end_date) }} </span>
			</template>
		</TimelineEvent>
	</div>
</template>

<script setup lang="ts">
import { computed, toRefs } from 'vue'
import { dateTimeFormattedShort } from '@/common/dateUtils'
import { StoreToPortalMap } from '@/common/utils'
import TimelineEvent from '@/features/events/components/timeline/events/TimelineEvent.vue'
import { useEvent } from '@/features/events/useEvent'
import type { EventDataWithStore } from '@/types'

const props = defineProps<{
	event: EventDataWithStore
	simplified?: boolean
	readonly?: boolean
	isSelected: boolean
}>()

const { event } = toRefs(props)

const { hasEnded, isClickable } = useEvent(event)

const title = computed(() => {
	let result = `${props.event.name}`

	if (hasEnded.value) {
		result += ' (ended)'
	}

	return result
})

const portal = computed(() => (props.event.storeName ? StoreToPortalMap.get(props.event.storeName) : undefined))
const portalColorVar = computed(() => ({
	'--event-portal-color': `var(--color-portal-${portal.value}-primary)`
}))
</script>

<style lang="scss" scoped>
.specialDiscountEvent {
	background-color: rgb(from var(--event-portal-color) r g b / 0.5);

	color: theme('colors.ink.87');
	border: none;

	&:hover,
	&.is-selected {
		background-color: rgb(from var(--event-portal-color) r g b / 0.8);
	}
}
</style>
